<div class="logout-container">
  <div class="container vertical-center">
    <div class="row justify-content-center w-100">
      <div class="col-xl-5 col-lg-6 col-md-7 col-sm-10 col-10">
        <img id="nice-img" src="assets/images/nice-logo-black-with-white.png"/>
        <div class="card rounded-0">
          <div class="card-body">
            <div id="status-completed">
              <img id="status-completed-img" src="assets/images/status_completed.svg"/>
            </div>
            <div id="logout-message">
              <p id="logout-message-p">{{"logout.message" | translate}}</p>
            </div>
            <button type="button" id="btnGoLoginPage" class="btn btn-primary btn-lg btn-block" (click)="goLoginPage()">{{"logout.btn.goLoginPage" | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="row copyRight-contactUs" id="copyRight-contactUs">
    <span id="copyrightMessage">{{copyrightMessage}}</span>
  </footer>
</div>

